// LIST
export const FETCH_ROLES = "app/ROSTER_ROLE/FETCH_ROLES";
export const FETCH_ROLES_SUCCESS = "app/ROSTER_ROLE/FETCH_ROLES_SUCCESS";
export const FETCH_ROLES_FAILURE = "app/ROSTER_ROLE/FETCH_ROLES_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/ROSTER_ROLE/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/ROSTER_ROLE/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/ROSTER_ROLE/GET_VIEW_DATA_FAILURE";
// ADD
export const ADD_ROLES = "app/ROSTER_ROLE/ADD_ROLES";
export const ADD_ROLES_SUCCESS = "app/ROSTER_ROLE/ADD_ROLES_SUCCESS";
export const ADD_ROLES_FAILURE = "app/ROSTER_ROLE/ADD_ROLES_FAILURE";
// EDIT
export const EDIT_ROLES = "app/ROSTER_ROLE/EDIT_ROLES";
export const EDIT_ROLES_SUCCESS = "app/ROSTER_ROLE/EDIT_ROLES_SUCCESS";
export const EDIT_ROLES_FAILURE = "app/ROSTER_ROLE/EDIT_ROLES_FAILURE";
// DELETE
export const DELETE_ROLES = "app/ROSTER_ROLE/DELETE_ROLES";
export const DELETE_ROLES_SUCCESS = "app/ROSTER_ROLE/DELETE_ROLES_SUCCESS";
export const DELETE_ROLES_FAILURE = "app/ROSTER_ROLE/DELETE_ROLES_FAILURE";
// LIST
export const SEARCH_ROLES = "app/ROSTER_ROLE/SEARCH_ROLES";
export const SEARCH_ROLES_SUCCESS = "app/ROSTER_ROLE/SEARCH_ROLES_SUCCESS";
export const SEARCH_ROLES_FAILURE = "app/ROSTER_ROLE/SEARCH_ROLES_FAILURE";
//
export const SET_ROLE = "app/ROSTER_ROLE/SET_ROLE";
export const SET_ROLE_SUCCESS = "app/ROSTER_ROLE/SET_ROLE_SUCCESS";
export const SET_ROLE_FAILURE = "app/ROSTER_ROLE/SET_ROLE_FAILURE";
//
export const UPDATE_SEQ = "app/ROSTER_ROLE/UPDATE_SEQ";
export const UPDATE_SEQ_SUCCESS = "app/ROSTER_ROLE/UPDATE_SEQ_SUCCESS";
export const UPDATE_SEQ_FAILURE = "app/ROSTER_ROLE/UPDATE_SEQ_FAILURE";

export const SEARCH_EMP_ROLES = "app/ROSTER_ROLE/SEARCH_EMP_ROLES";
export const SEARCH_EMP_ROLES_SUCCESS =
  "app/ROSTER_ROLE/SEARCH_EMP_ROLES_SUCCESS";
export const SEARCH_EMP_ROLES_FAILURE =
  "app/ROSTER_ROLE/SEARCH_EMP_ROLES_FAILURE";

export const FETCH_HISTORY = "app/ROSTER_ROLE/FETCH_HISTORY";
export const FETCH_HISTORY_SUCCESS = "app/ROSTER_ROLE/FETCH_HISTORY_SUCCESS";
export const FETCH_HISTORY_FAILURE = "app/ROSTER_ROLE/FETCH_HISTORY_FAILURE";
export const TOGGLE_HISTORY_MODAL = "app/ROSTER_ROLE/TOGGLE_HISTORY_MODAL";
